import { Injectable } from '@angular/core';

/**
 * Firebase is heavy (~hundreds of KB). It used to be imported and initialised at
 * module-load time in AppComponent. This service defers the entire Firebase
 * bundle until the first analytics event actually needs to fire, and is a no-op
 * on the server.
 */
const firebaseConfig = {
  apiKey: 'AIzaSyCakRl9tIQ6Kux4j216JB5bAXTThmPGiCU',
  authDomain: 'bubs-android-apps.firebaseapp.com',
  databaseURL: 'https://bubs-android-apps.firebaseio.com',
  projectId: 'bubs-android-apps',
  storageBucket: 'bubs-android-apps.firebasestorage.app',
  messagingSenderId: '575714629381',
  appId: '1:575714629381:web:784c0b39405d48caa2096c',
  measurementId: 'G-B6BT4HWJ16',
};

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private analyticsPromise?: Promise<unknown>;

  private load(): Promise<unknown> {
    if (typeof window === 'undefined') {
      return Promise.resolve(null);
    }
    if (!this.analyticsPromise) {
      this.analyticsPromise = (async () => {
        try {
          const [{ initializeApp, getApps }, analyticsMod] = await Promise.all([
            import('firebase/app'),
            import('firebase/analytics'),
          ]);
          if (!(await analyticsMod.isSupported())) {
            return null;
          }
          const app = getApps().length
            ? getApps()[0]
            : initializeApp(firebaseConfig);
          return analyticsMod.getAnalytics(app);
        } catch {
          return null;
        }
      })();
    }
    return this.analyticsPromise;
  }

  /** Fire an analytics event. Safe to call before Firebase has loaded. */
  async logEvent(name: string, params?: Record<string, unknown>): Promise<void> {
    const analytics = await this.load();
    if (!analytics) {
      return;
    }
    const { logEvent } = await import('firebase/analytics');
    logEvent(analytics as never, name as never, params as never);
  }

  logGooglePlayClick(): Promise<void> {
    return this.logEvent('hxPlayerWebToPlayStore', { toPlayStoreClick: '1' });
  }
}
